export interface Place {
  id: string
  name: string
  region: string
  unlockEchoes: number
  adjacentPlaces: string[]
}

export const PLACES: Record<string, Place> = {
  'embuns-clearing': {
    id: 'embuns-clearing',
    name: "Embun's Clearing",
    region: 'padang-embun',
    unlockEchoes: 0,
    adjacentPlaces: ['tall-grass-way'],
  },
  'tall-grass-way': {
    id: 'tall-grass-way',
    name: 'Tall Grass Way',
    region: 'padang-embun',
    unlockEchoes: 3,
    adjacentPlaces: ['embuns-clearing'],
  },
}

export interface Region {
  id: string
  name: string
  meaning: string
  unlockHours: number
  places: string[]
}

export const REGIONS: Record<string, Region> = {
  'padang-embun': {
    id: 'padang-embun',
    name: 'Padang Embun',
    meaning: 'Dew Field',
    unlockHours: 0,
    places: ['embuns-clearing', 'tall-grass-way'],
  },
}

export const PLACE_LIST = Object.values(PLACES)
export const REGION_LIST = Object.values(REGIONS)
